var _ellipse, _g, _g2, _g3, _g4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyStateUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 220 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.18,
    filter: "url(#filter0_f_2761_477431)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.4276,
    cy: 82.9315,
    rx: 31.1151,
    ry: 30.5595,
    fill: "#F28815"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_2761_477431)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.6699,
    y: 58.7803,
    width: 72.7871,
    height: 72.7871,
    rx: 36.3936,
    fill: "url(#paint0_linear_2761_477431)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.1699,
    y: 59.2803,
    width: 71.7871,
    height: 71.7871,
    rx: 35.8936,
    stroke: "url(#paint1_linear_2761_477431)",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.759 81.9223L95.9934 101.564C95.7508 101.984 95.6225 102.46 95.6211 102.945C95.6197 103.43 95.7454 103.907 95.9856 104.329C96.2259 104.75 96.5722 105.101 96.9903 105.347C97.4084 105.593 97.8836 105.726 98.3687 105.731H121.899C122.385 105.726 122.86 105.593 123.278 105.347C123.696 105.101 124.042 104.75 124.283 104.329C124.523 103.907 124.648 103.43 124.647 102.945C124.646 102.46 124.517 101.984 124.275 101.564L112.509 81.9223C112.262 81.514 111.913 81.1765 111.497 80.9423C111.081 80.708 110.612 80.585 110.134 80.585C109.657 80.585 109.187 80.708 108.771 80.9423C108.355 81.1765 108.006 81.514 107.759 81.9223V81.9223Z",
    stroke: "#F28815",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.133 89.0625V94.6188",
    stroke: "#F28815",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.133 100.175H110.146",
    stroke: "#F28815",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.854 113.571L152.353 119.072",
    stroke: "#F28815",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.354 113.571L157.854 119.072",
    stroke: "#F28815",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip0_2761_477431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.039 128.609L146.83 131.818",
    stroke: "#F28815",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.832 128.609L150.041 131.818",
    stroke: "#F28815",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.8809 55.1934L66.1925 66.8818",
    stroke: "#F28815",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1934 55.1934L77.8818 66.8818",
    stroke: "#F28815",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2761_477431",
    x: 0.3125,
    y: 0.37207,
    width: 166.23,
    height: 165.119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26,
    result: "effect1_foregroundBlur_2761_477431"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_2761_477431",
    x: 58.6699,
    y: 43.7803,
    width: 102.787,
    height: 102.787,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2761_477431"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2761_477431",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2761_477431",
    x1: 44.5551,
    y1: 13.6085,
    x2: 184.053,
    y2: 70.5364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBCC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBCC7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2761_477431",
    x1: 44.5551,
    y1: 13.6085,
    x2: 184.053,
    y2: 70.5364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBCC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBCC7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2761_477431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.77878,
    height: 7.77878,
    fill: "white",
    transform: "translate(148.436 124.713) rotate(45)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateUsers);
export default __webpack_public_path__ + "static/media/empty-state-users.48cb871155872004b9c53fe15f7baf94.svg";
export { ForwardRef as ReactComponent };